<template>
  <div>
    <!-- pc端 -->
    <div v-if="isPC" class="main">
      <!-- 面包屑 -->
      <el-breadcrumb separator-class="el-icon-arrow-right" style="margin: 15px 0">
        <el-breadcrumb-item :to="{ path: '/commodity/in-stock' }">{{$t('productDetail.product')}}</el-breadcrumb-item>
        <el-breadcrumb-item>{{$t('currency.confirmOrder')}}</el-breadcrumb-item>
      </el-breadcrumb>

      <h3 style="margin-bottom: 15px; font-size:18px;">{{$t('currency.confirmOrder')}}</h3>
      <!-- main content -->
      <div class="content f-b">
        <!-- left  -->
        <div class="left">
          <!-- 账号 -->
          <div v-if="!$store.state.common.userId || ($store.state.common.userId && is_login)" class="account bg-white">
            <h3>{{$t('commodity.ConfirmOrder.ContactInformation')}}</h3>
            <div class="text">{{$t('commodity.ConfirmOrder.AlreadyHaveAnAccount')}} <span class="pointer" @click="jumpLogin">{{$t('commodity.ConfirmOrder.LogIn')}}</span></div>
            <div class="f-b-c" style="padding: 20px 80px 0 0;">
              <el-form style="width:100%" label-width="100px" :model="userForm" :rules="rules" ref="loginForm" class="form-class">
                <el-form-item :label="$t('commodity.ConfirmOrder.Email')" prop="email">
                  <el-input :disabled="is_login" style="width:400px" v-model.trim="userForm.email" :placeholder="$t('commodity.ConfirmOrder.InputContent')" @blur="authEmailExist"></el-input>
                </el-form-item>
                <el-checkbox v-model="isRegister" :label="$t('commodity.ConfirmOrder.RegisterAsANewAccount')" name="type" style="padding-top:8px" @change="authEmailExist"></el-checkbox>
                <!-- <el-form-item label="Password" prop="password">
                  <el-input :disabled="is_login" style="width:200px" type="password" v-model.trim="userForm.password" show-password @blur="logoutSignUp"></el-input>
                </el-form-item> -->
              </el-form>
              <!-- <div>
                Email：<el-input v-model="email" style="width:260px" @blur="logoutSignUp"></el-input>
              </div>
              <div>
                Password：<el-input v-model="password" style="width:260px" @blur="logoutSignUp"></el-input>
              </div> -->
            </div>
            <dir v-if="is_login" class="f--c" style="padding-left:100px">
              <i class="iconfont icon-checkbox-circle-fill" style="color:#99C41C;font-size:22px;margin-right:10px"></i>
              {{$t('commodity.ConfirmOrder.LoginSuccessful')}}
            </dir>
          </div>
          <!-- 收货地址管理 -->
          <div class="address bg-white p-r">
            <h3>{{$t('confirmOrder.shippingAddress')}}</h3>

            <div class="current-address" v-if="this.addressList.length">
              {{addressList[selectAddressIndex].fullName}} {{addressList[selectAddressIndex].phoneNumber}}
              <p>{{addressList[selectAddressIndex].streetAddressLine1}}</p>
              <p v-if="addressList[selectAddressIndex].streetAddressLine2">{{addressList[selectAddressIndex].streetAddressLine2}}</p>
              {{addressList[selectAddressIndex].city}} {{addressList[selectAddressIndex].province}} {{addressList[selectAddressIndex].countryName}} {{addressList[selectAddressIndex].zipCode}} {{addressList[selectAddressIndex].vatCode}}
            </div>
            <el-button v-else type="primary" class="add-address" @click="showAddressdialog">
              <i class="iconfont icon-map-pin-2-line"></i>
              {{$t('confirmOrder.addNewAddress')}}
            </el-button>
            <el-popover placement="bottom">
              <span v-show="addressList.length" class="select-another-address pointer" slot="reference">{{$t('confirmOrder.selectAnotherAddress')}}</span>
              <vue-scroll :style="{ height: `${addressList.length > 3 ? '400': addressList.length*200}px`}">
                <div @click.stop="addAddressdialog" class="add-new-address f-c">
                  <i class="iconfont icon-a-add-line1"></i>&nbsp;
                  <span>{{ $t('confirmOrder.addNewAddress') }}</span>
                </div>
                <div v-for="(item, index) in addressList" :key="item.id" class="address-item p-r pointer" :class="[index === selectAddressIndex ? 'address-item-activated' : '']" @click="addressIndexChange(index)">
                  {{item.fullName}} {{item.phoneNumber}}
                  <p>{{item.streetAddressLine1}}</p>
                  <p v-if="item.streetAddressLine2">{{item.streetAddressLine2}}</p>
                  {{item.city}} {{item.province}} {{item.countryName}} {{item.zipCode}} {{item.vatCode}}
                  <span class="pointer" @click.stop="editAddress(item)">{{$t('confirmOrder.editTheAddress')}}</span>
                  <div class="activated-icon">
                    <i class="iconfont icon-check-line"></i>
                  </div>
                </div>
              </vue-scroll>
            </el-popover>
          </div>
          <!-- 备注 -->
          <div class="remark bg-white mb10 f--c">
            {{$t('confirmOrder.remark')}}：<el-input v-model="remark" :placeholder="$t('commodity.ConfirmOrder.LeaveUsYourRequirement')"></el-input>
          </div>
          <!-- 商品列表 -->
          <div v-for="(item, index) in productList" :key="item.warehouseId" class="product-block bg-white">
            <div class="top f-b-c">
              <span>{{$t('productDetail.shipFrom')}}: {{item.shipFromText}}</span>
              <span>{{$t('productDetail.shippingCost')}}: ${{item.freightAmount || 0 | money}}</span>
              <!-- 物流渠道列表 -->
              <el-popover placement="bottom" v-model="item.visible">
                <div class="shipping f-b-c pointer" slot="reference">
                  {{$t('commodity.ConfirmOrder.Shipping')}}
                  <i class="iconfont icon-Frame_3"></i>
                </div>
                <ChannelSelectionDialog ref="channelSelectionDialog" :channelList.sync="item.logisticsChannel" @change="(channel) => channelChange(channel, index)" :termini='countryCode'></ChannelSelectionDialog>
              </el-popover>
            </div>
            <!-- 商品列表 -->
            <el-table :data="item.orderItems" style="width: 100%">
              <el-table-column :label="$t('productDetail.description')" width="400">
                <template slot-scope="scope">
                  <Description :img="scope.row.sizeImagePath" :title="scope.row.productName" :color="scope.row.color" :size="scope.row.size"></Description>
                </template>
              </el-table-column>
              <el-table-column :label="$t('productDetail.qty')" width="177">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.productNum" type="number" :min="1" :max="scope.row.stock" @change="getLogisticsChannel(index, scope.row)"></el-input>
                </template>
              </el-table-column>
              <el-table-column :label="$t('confirmOrder.unitPrice')">
                <template slot-scope="scope">
                  <span v-if="scope.row.afterDiscountAmount >= 0">
                    <span class="discount-price">${{scope.row.afterDiscountAmount | money}}</span>
                    <span class="original-price">${{scope.row.purchasePrices | money}}</span>
                  </span>
                  <span v-else>${{scope.row.purchasePrices | money}}</span>
                  <i v-if="!(productList.length===1 && item.orderItems.length===1)" class="iconfont icon-a-delete-bin-6-line5 pointer" style="float: right;" @click="deleteProduct(index, scope.$index)"></i>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <!-- right -->
        <div class="right">
          <div class="top bg-white">
            <div class="title">{{$t('commodity.ConfirmOrder.PromotionalCodes')}}</div>
            <div class="coupon-code f--c">
              <el-input v-model="couponCode" class="coupon-code-input" clearable @clear="clearCouponCode" @blur="clearCouponCode"></el-input>
              <el-button type="primary" :loading="couponInfo.loading" class="coupon-code-btn" @click="couponApply">{{$t('commodity.ConfirmOrder.Apply')}}</el-button>
            </div>
            <div v-if="couponInfo.message && !couponInfo.error" class="f-c-c">
              <i class="iconfont icon-checkbox-circle-fill success" style="font-size:22px;margin-right:6px"></i>
              <div>{{ couponInfo.message }}</div>
            </div>
            <div v-if="couponInfo.message && couponInfo.error" class="f-c-c error">
              <i class="iconfont icon-a-close-line1"></i>
              <div>{{ couponInfo.message }}</div>
            </div>
            <div v-if="couponInfo.message && !couponInfo.error" class="coupon-bar f-c-c">
              <img src="@/assets/img/icon/coupon.svg" style="margin-right:6px" alt="">
              <div v-if="+couponInfo.discountRule === 3">{{$t('commodity.ConfirmOrder.DeductionForHighestProductPrice')}}</div>
              <div v-else>{{ `${couponInfo.discountCondition===1?('Order '+couponInfo.satisfyNum+', '):couponInfo.discountCondition===2?('Spend $'+couponInfo.satisfyAmount+', '):''}` }}Get <span class="error">{{`${couponInfo.discountRule===1?(couponInfo.discountPercent+'% off'):('$'+couponInfo.discountFixed+' off')}`}}</span></div>
            </div>
          </div>
          <!-- 支付信息 -->
          <div class="total-payable bg-white">
            <h3>{{$t('confirmOrder.totalPayable')}}</h3>
            <p class="f-b-c">
              <span>{{$t('confirmOrder.subtotal')}}</span>
              <span>${{itemSubtotal | money}}</span>
            </p>
            <p class="f-b-c">
              <span>{{$t('confirmOrder.shippingSubtotal')}}</span>
              <span>${{shippingSubtotal | money}}</span>
            </p>
            <p v-if="promotionSubtotal > 0" class="f-b-c">
              <span>{{$t('confirmOrder.promotion')}}</span>
              <span class="class-red">${{promotionSubtotal | money}}</span>
              <!-- <span :class="{ 'class-red': couponInfo.message && !couponInfo.error }">${{promotionSubtotal | money}}</span> -->
            </p>
          </div>
          <!-- pay -->
          <div class="pay bg-white mb10">
            <p class="grand-total f-b-c">
              <span>{{$t('confirmOrder.grandTotal')}}:</span>
              <span>${{grandTotal | money}}</span>
            </p>

            <el-radio-group v-model="paymentMethod">
              <el-radio label="0">{{$t('confirmOrder.balance')}} ${{balance}}</el-radio>
              <!-- <el-radio label="1" :disabled="+grandTotal <= 0">
                {{$t('confirmOrder.creditCard')}}
                <img class="pay-icon" src="../../assets/img/icon/creditcard1.png" alt="">
              </el-radio> -->
              <el-radio label="4" :disabled="+grandTotal <= 0">
                {{$t('commodity.ConfirmOrder.Creditcard')}}
                <img class="pay-icon" src="../../assets/img/icon/creditcard1.png" alt="">
              </el-radio>
              <el-radio label="2" :disabled="+grandTotal <= 0">
                {{$t('commodity.ConfirmOrder.Paypal')}}
                <img class="pay-icon" src="../../assets/img/icon/paypal.png" alt="">
              </el-radio>
              <el-radio label="3" :disabled="+grandTotal <= 0">
                {{$t('commodity.ConfirmOrder.Others')}}
                <img class="pay-icon" src="../../assets/img/icon/zfb_wx.png" alt="">
              </el-radio>
            </el-radio-group>

            <el-button class="proceed_to_checkout" type="primary" @click="clickPay">{{$t('confirmOrder.payNow')}}</el-button>
          </div>
          <!-- 常见问题 -->
          <div class="common-problem bg-white">
            <h3>{{$t('confirmOrder.commonProblem')}}</h3>
            <el-collapse accordion>
              <el-collapse-item :title="$t('commodity.ConfirmOrder.Tips4')" name="1">
                <div>{{$t('commodity.ConfirmOrder.TipsOne')}}</div>
              </el-collapse-item>
              <el-collapse-item :title="$t('commodity.ConfirmOrder.Tips5')" name="2">
                <div>{{$t('commodity.ConfirmOrder.TipsTwo')}}</div>
              </el-collapse-item>
              <el-collapse-item :title="$t('commodity.ConfirmOrder.Tips6')" name="4">
                <div>{{$t('commodity.ConfirmOrder.TipsThree')}}</div>
              </el-collapse-item>
            </el-collapse>
          </div>
        </div>
      </div>
    </div>
    <!-- 移动端 -->
    <div v-else class="mobile-confirm-order">
      <div v-if="addressList.length === 0" class="mobile-address-box f mb10" style="padding: .26rem" @click="addAddressdialog">
        <p style="color: #99C41C;">+ {{$t('commodity.ConfirmOrder.AddANewAddress')}}</p>
        <i class="iconfont icon-Frame_2"></i>
      </div>
      <div v-else style="padding: .3rem .3rem 0" class="mb10">
        <el-popover placement="bottom" popper-class="mobile-address-list-popover">
          <div class="mobile-address-box f" slot="reference">
            <i class="iconfont icon-map-pin-2-line"></i>
            <div class="mobile-address-info" v-if="addressList.length">
              <p>{{addressList[selectAddressIndex].fullName}} {{addressList[selectAddressIndex].phoneNumber}}</p>
              <p>{{addressList[selectAddressIndex].streetAddressLine1}}</p>
              <p v-if="addressList[selectAddressIndex].streetAddressLine2">{{addressList[selectAddressIndex].streetAddressLine2}}</p>
              <p>{{addressList[selectAddressIndex].city}} {{addressList[selectAddressIndex].province}} {{addressList[selectAddressIndex].countryName}} {{addressList[selectAddressIndex].zipCode}} {{addressList[selectAddressIndex].vatCode}}</p>
            </div>
            <i class="iconfont icon-Frame_2"></i>
          </div>
          <div class="f-c-c" @click="addAddressdialog" style="height:40px">
            <p style="color: #99C41C;"><i class="iconfont icon-a-add-line1"></i>&nbsp;{{$t('confirmOrder.addNewAddress')}}</p>
            <!-- <i class="iconfont icon-Frame_2"></i> -->
          </div>
          <div v-for="(item, index) in addressList" :key="item.id" style="width: 90vw" class="address-item p-r pointer" :class="[index === selectAddressIndex ? 'address-item-activated' : '']" @click="addressIndexChange(index)">
            {{item.fullName}} {{item.phoneNumber}}
            <p>{{item.streetAddressLine1}}</p>
            <p v-if="item.streetAddressLine2">{{item.streetAddressLine2}}</p>
            {{item.city}} {{item.province}} {{item.countryName}} {{item.zipCode}} {{item.vatCode}}
            <span class="pointer" @click.stop="editAddress(item)">{{$t('confirmOrder.editTheAddress')}}</span>
            <div class="activated-icon">
              <i class="iconfont icon-check-line"></i>
            </div>
          </div>
        </el-popover>
      </div>

      <div class="mb10 p-lr">
        <div class="mobile-confirm-order-line f-b-c">
          <span class="left">{{$t('productDetail.shipFrom')}}</span>
          <span class="right">{{firstProduct.shipFromText || ''}}</span>
        </div>
        <div class="mobile-confirm-order-line f-b-c">
          <span class="left">{{$t('commodity.ConfirmOrder.ShipMethod')}}</span>
          <el-popover placement="bottom" trigger="click">
            <span slot="reference" class="right">
              {{$t('commodity.ConfirmOrder.AnotherMethod')}}
              <i class="iconfont icon-Frame_2"></i>
            </span>
            <ChannelSelectionDialog ref="channelSelectionDialog" :channelList.sync="firstProduct.logisticsChannel" @change="(channel) => channelChange(channel, 0)" :termini='countryCode'></ChannelSelectionDialog>
          </el-popover>
        </div>
        <p class="mobile-confirm-order-delivery-time">{{$t('commodity.ConfirmOrder.DeliveryTime')}} <span>{{mobileActivatedChannel.deliveryTime}}，{{$t('commodity.ConfirmOrder.Cost')}} ${{mobileActivatedChannel.estimatedFreight | money}}</span></p>
        <div class="mobile-confirm-order-line f-b-c" style="border:0">
          <span class="left">{{$t('commodity.ConfirmOrder.ShippingCost')}}</span>
          <span class="right">${{mobileActivatedChannel.estimatedFreight | money}}</span>
        </div>
      </div>

      <!-- 商品列表 -->
      <div class="p-lr" style="margin-bottom:.06rem">
        <template v-for="(item, index1) in productList">
          <div v-for="(product, index2) in item.orderItems" :key="product.id" class="mobile-confirm-order-product f">
            <img :src="product.sizeImagePath" class="mobile-confirm-order-product-img">
            <div>
              <p class="mobile-confirm-order-product-name ellipsis2" :title="product.productName">{{product.productName}}</p>
              <p class="mobile-confirm-order-product-color">{{product.color}},{{product.size}}</p>
              <ProductQuantity v-model="product.productNum" class="mobile-confirm-order-product-quantity" :max="product.stock" @quantityChange="quantityChange"></ProductQuantity>
              <div v-if="product.afterDiscountAmount >= 0" class="mobile-confirm-order-product-price mobile-confirm-order-product-price-discount">
                <s>${{product.purchasePrices | money}}</s>
                <span>${{product.afterDiscountAmount | money}}</span>
              </div>
              <p v-else class="mobile-confirm-order-product-price">${{product.purchasePrices | money}}</p>
              <i v-show="productList.length > 1" slot="reference" class="iconfont icon-a-delete-bin-6-line5" @click="deleteProduct(index1, index2)"></i>
            </div>
          </div>
        </template>
      </div>

      <!-- 备注 -->
      <div class="mobile-confirm-order-remark f-b-c mb10">
        <!-- <span class="left">Notes</span> -->
        <el-input class="mobile-confirm-order-remark" type="textarea" :rows="2" v-model="remark" :placeholder="$t('commodity.ConfirmOrder.LeaveUsYourRequirement')" />
      </div>

      <!-- 是否添加配件 -->
      <div class="productParts bg-white content_item">
        <p class="title">{{$t('commodity.ConfirmOrder.CustomizedService')}}</p>
        <el-checkbox-group v-model="attachmentSelectedList">
          <div style="display: inline-block; margin-right: 2vw;" v-for="item in defaultAttachmentsList" :key="item">
              <el-checkbox :key="item" :label="item" :disabled="!attachmentsList.some(e=>e.type === item)"></el-checkbox>
          </div>
          <!-- 目前只有一个吊牌，待后续新增后再去除这两个 -->
          <!-- <template v-if="attachmentsList.length < 2">
            <el-checkbox :label="$t('commodity.ConfirmOrder.Package')" :disabled="true"></el-checkbox>
            <el-checkbox :label="$t('commodity.ConfirmOrder.Bags')" :disabled="true"></el-checkbox>
            <el-checkbox :label="$t('commodity.ConfirmOrder.Cards')" :disabled="true"></el-checkbox>
          </template> -->
        </el-checkbox-group>
      </div>

      <!-- 支付方式 -->
      <div class="mobile-payment-method mb10 p-lr">
        <p class="mobile-payment-method-title">{{$t('commodity.ConfirmOrder.PaymentMethod')}}</p>
        <div class="f-b-c" @click="checkBalance()">
          <p>{{$t('confirmOrder.balance')}} ${{balance}}</p>
          <span class="radio" :style="{backgroundColor:+balance > orderBillingPreviewInfo.transactionTotalAmount?'unset':'#eee'}" :class="[+paymentMethod === 0 && balance > orderBillingPreviewInfo.transactionTotalAmount ? 'radio-activated' : '']"></span>
        </div>
        <!-- <div class="f-b-c" @click="paymentMethod = 1">
          <p>
            {{$t('confirmOrder.creditCard')}}
            <img class="pay-icon" src="../../assets/img/icon/creditcard1.png" alt="">
          </p>
          <span class="radio" :class="[+paymentMethod === 1 ? 'radio-activated' : '']"></span>
        </div> -->
        <!-- <div v-if="$store.state.common.userGroup === 100" class="f-b-c" @click="paymentMethod = 4">
          <p>
            {{$t('commodity.ConfirmOrder.Creditcard')}}
            <img class="pay-icon" src="../../assets/img/icon/creditcard1.png" alt="">
          </p>
          <span class="radio" :class="[+paymentMethod === 4 ? 'radio-activated' : '']"></span>
        </div>
        <div v-else class="f-b-c" @click="paymentMethod = 9">
          <p>
            {{$t('commodity.ConfirmOrder.Creditcard')}}
            <img class="pay-icon" src="../../assets/img/icon/creditcard1.png" alt="">
          </p>
          <span class="radio" :class="[+paymentMethod === 9 ? 'radio-activated' : '']"></span>
        </div> -->
        <!-- 2025.06.09 信用卡逻辑调整 全部用空中云汇的（陈琼瑜） -->
        <div class="f-b-c" @click="paymentMethod = 4">
          <p>
            {{$t('commodity.ConfirmOrder.Creditcard')}}
            <img class="pay-icon" src="../../assets/img/icon/creditcard1.png" alt="">
          </p>
          <span class="radio" :class="[+paymentMethod === 4 ? 'radio-activated' : '']"></span>
        </div>
        <div class="f-b-c" @click="paymentMethod = 2">
          <p>
            {{$t('commodity.ConfirmOrder.Paypal')}}
            <img class="pay-icon" src="../../assets/img/icon/paypal.png" alt="">
          </p>
          <span class="radio" :class="[+paymentMethod === 2 ? 'radio-activated' : '']"></span>
        </div>
        <div class="f-b-c" @click="paymentMethod = 3">
          <p>
            {{$t('commodity.ConfirmOrder.Others')}}
            <img class="pay-icon" src="../../assets/img/icon/zfb_wx.png" alt="">
          </p>
          <span class="radio" :class="[+paymentMethod === 3 ? 'radio-activated' : '']"></span>
        </div>
      </div>

      <!-- 优惠码 -->
      <div class="coupon bg-white">
        <div class="coupon-code f--c">
          <el-input v-model="couponCode" class="coupon-code-input" :placeholder="$t('commodity.ConfirmOrder.CouponCode')" clearable @clear="clearCouponCode" @blur="clearCouponCode"></el-input>
          <el-button type="primary" :loading="couponInfo.loading" class="coupon-code-btn f-c-c" @click="couponApply">{{$t('commodity.ConfirmOrder.Apply')}}</el-button>
        </div>

        <p v-if="promoCodeMessage" style="color: #E3444E;text-align: center;">
          <i class="el-icon-circle-close" style="margin-right: 5px;"></i>
          <span>{{ promoCodeMessage }}</span>
        </p>

        <div v-if="couponInfo.message && !couponInfo.error" class="f-c-c">
          <i class="iconfont icon-checkbox-circle-fill success" style="font-size:22px;margin-right:6px"></i>
          <div>{{ couponInfo.message }}</div>
        </div>
        <div v-if="couponInfo.message && couponInfo.error" class="f-c-c error">
          <i class="iconfont icon-a-close-line1"></i>
          <div>{{ couponInfo.message }}</div>
        </div>
        <div v-if="couponInfo.message && !couponInfo.error" class="coupon-bar f-c-c">
          <img src="@/assets/img/icon/coupon.svg" style="margin-right:6px" alt="">
          <div>{{ `${couponInfo.discountCondition===1?('Order '+couponInfo.satisfyNum+', '):couponInfo.discountCondition===2?('Spend $'+couponInfo.satisfyAmount+', '):''}` }}{{$t('commodity.ConfirmOrder.Get')}} <span class="error">{{`${couponInfo.discountRule===1?(couponInfo.discountPercent+'% off'):('$'+couponInfo.discountFixed+' off')}`}}</span></div>
        </div>
      </div>

      <!-- 优惠券模块 -->
      <div class="cart-coupon" @click="onClickSelectCoupon">
        <span class="title">Coupons</span>
        <span class="tips">
          <span>
            <template v-if="coupon.id">
              <span>Get </span>
              <span v-if="getOfferTypePrice" class="chosen">{{coupon.receiveUsageRules.offerTypeInfo.fixedType === 1 ? `$${coupon.receiveUsageRules.offerTypeInfo.reduction}` : `$${coupon.receiveUsageRules.offerTypeInfo.reduction}% off`}}</span>
              <span v-else>-</span>
            </template>
            <template v-else-if="getAvailableCouponQuantity">
              <span class="info">
                <i class="iconfont icon-youhuiquan" />
                <span>{{ getAvailableCouponQuantity }} {{ getAvailableCouponQuantity > 1 ? 'Coupons' : 'Coupon' }} Available</span>
              </span>
            </template>
            <template v-else>No Coupons Available</template>
          </span>
          <i class="el-icon-arrow-right" />
        </span>
      </div>

      <!-- 订单金额 -->
      <!-- <div class="mobile-confirm-order-amount">
        <p class="mobile-confirm-order-amount-title">{{$t('commodity.ConfirmOrder.OrderAmount')}}</p>

        <div class="mobile-confirm-order-line f-b-c">
          <span class="left">{{$t('confirmOrder.subtotal')}}</span>
          <span class="right">${{itemSubtotal | money}}</span>
        </div>
        <div class="mobile-confirm-order-line f-b-c">
          <span class="left">{{$t('confirmOrder.shippingSubtotal')}}</span>
          <span class="right">${{shippingSubtotal | money}}</span>
        </div>
        <div v-if="promotionSubtotal > 0" class="mobile-confirm-order-line f-b-c">
          <span class="left">Promo code</span>
          <span :class="{ 'class-red': couponInfo.message && !couponInfo.error }">${{promotionSubtotal | money}}</span>
        </div>
        <div class="mobile-confirm-order-line f-b-c">
          <span class="left">{{$t('confirmOrder.grandTotal')}}</span>
          <span class="right">${{grandTotal | money}}</span>
        </div>
      </div> -->

      <!-- 订单金额 -->
      <div class="mobile-confirm-order-amount">
        <p class="mobile-confirm-order-amount-title">{{$t('commodity.ConfirmOrder.OrderAmount')}}</p>

        <div class="mobile-confirm-order-line f-b-c">
          <span class="left">{{$t('confirmOrder.subtotal')}}</span>
          <span class="right">${{itemSubtotal | money}}</span>
        </div>
        <div class="mobile-confirm-order-line f-b-c">
          <span class="left">{{$t('confirmOrder.shippingSubtotal')}}</span>
          <span class="right">${{orderBillingPreviewInfo.shippingSubtotal | money}}</span>
        </div>
        <div v-if="orderBillingPreviewInfo.couponCodeTotalAmount" class="mobile-confirm-order-line f-b-c">
          <span class="left">Promo code</span>
          <span :class="{ 'class-red': orderBillingPreviewInfo.couponCodeTotalAmount }">${{orderBillingPreviewInfo.couponCodeTotalAmount | money}}</span>
        </div>
        <div v-if="orderBillingPreviewInfo.couponTicketTotalAmount" class="mobile-confirm-order-line f-b-c">
          <span class="left">Coupon</span>
          <span :class="{ 'class-red': orderBillingPreviewInfo.couponTicketTotalAmount }">${{orderBillingPreviewInfo.couponTicketTotalAmount | money}}</span>
        </div>
        <div class="mobile-confirm-order-line f-b-c">
          <span class="left">{{$t('confirmOrder.grandTotal')}}</span>
          <span class="right">${{orderBillingPreviewInfo.transactionTotalAmount | money}}</span>
        </div>
      </div>

      <!-- 优惠券选择上拉框 -->
      <VantPopup v-model="showVantPopup" position="bottom" closeable :style="{ height: '500px' }">
        <div class="vant-popup-title">Coupons</div>
        <VantTabs v-model="activeVantTabs">
          <VantTab title="Available" name="Available">
            <ul v-if="getCouponListByStatus(1).length" class="car-coupons-ul">
              <CouponItem v-for="coupon in getCouponListByStatus(1)" :key="coupon.id" :coupon="coupon" @click="onClickCoupon" />
            </ul>

            <!-- 空状态 -->
            <template v-else>
              <div class="not-data">
                <img src="~@/assets/img/coupon.png" alt="img.svg" />
                <span class="tips-text">{{ $t('Order.Refund.Mobile.Index.NoRecord') }}</span>
              </div>
            </template>
          </VantTab>
          <VantTab title="Unavailable" name="Unavailable">
            <ul v-if="getCouponListByStatus(0).length" class="car-coupons-ul">
              <CouponItem v-for="coupon in getCouponListByStatus(0)" :key="coupon.id" :coupon="coupon" />
            </ul>

            <!-- 空状态 -->
            <template v-else>
              <div class="not-data">
                <img src="~@/assets/img/coupon.png" alt="img.svg" />
                <span class="tips-text">{{ $t('Order.Refund.Mobile.Index.NoRecord') }}</span>
              </div>
            </template>
          </VantTab>
        </VantTabs>
      </VantPopup>

      <Footer>
        <el-button class="proceed_to_checkout" type="primary" style="width: 100%;" @click="clickPay">{{$t('confirmOrder.payNow')}}</el-button>
      </Footer>
    </div>
    <!-- 新增银行卡弹窗 -->
    <!-- <CardDialog></CardDialog> -->
    <QianHai ref="qianhai" @success="paySuccess" @fail="payFail" @cancel="payCancel"></QianHai>
    <Paypal ref="paypal" @success="paySuccess" @fail="payFail" @cancel="payCancel"></Paypal>
    <Airwallex ref="airwallex" :payCallbackUrl="payCallbackUrl" @success="paySuccess" @fail="payFail" @cancel="payCancel" />
    <Payoneer ref="payoneer" :payCallbackUrl="payoneerCallbackUrl" @cancel="payCancel" />
    <!-- 新增收货地址 -->
    <AddressDialog ref="addressdialog" :addForm="addressForm" @submitForm="getAddressList"></AddressDialog>
  </div>
</template>

<script>
// 优惠券模块
import { Tab as VantTab } from 'vant'
import { Tabs as VantTabs } from 'vant'
import { Popup as VantPopup } from 'vant'
import 'vant/lib/tab/style'
import 'vant/lib/tabs/style'
import 'vant/lib/popup/style'
import CouponItem from '@/components/CouponItem.vue'

import Description from './components/Description.vue'
// import CardDialog from '@/components/CardDialog.vue'
import QianHai from '@/components/QianHai.vue'
import Paypal from '@/components/Paypal.vue'
import Airwallex from '@/components/Airwallex.vue'
import Payoneer from '@/components/Payoneer.vue'
import ChannelSelectionDialog from './components/ChannelSelectionDialog.vue'
import AddressDialog from '@/views/commodity/components/AddressDialog'
import ProductQuantity from '@/components/ProductQuantity'
import Footer from '@/components/mobile/Footer'
import _ from 'lodash'
import API from '@/api'
import { dateFormat } from '@/util/date'
import math from '@/util/math'
import bus from '@/util/bus'
import { encrypt } from '@/util/encryp.js'
import { checkEmail } from '@/util/validate'
import googleLoginMixin from '@/views/home/js/googleLogin.js'
import { randomString } from '@/util/random.js'
import { gtagReport } from '@/util/gtag'
// 商品总重量<g>限制
const PRODUCT_MAX_WEIGHT = 30 * 1000 // 30 KG

let validateEmail = (rule, value, callback) => {
  if (checkEmail(value)) {
    callback()
  } else {
    callback(new Error('Please enter your vaild email'))
  }
}

export default {
  mixins: [googleLoginMixin],
  components: { Description, QianHai, Paypal, Airwallex, Payoneer, ChannelSelectionDialog, ProductQuantity, Footer, AddressDialog, VantPopup, VantTab, VantTabs, CouponItem },
  data() {
    return {
      showVantPopup: false,
      activeVantTabs: 'Available',
      // 优惠券模块 - 当前选中的优惠券
      coupon: {},

      promoCodeMessage: undefined, // 优惠码错误的提示语

      // 优惠券模块 - 优惠券列表
      coupons: [
        // {
        //   id: 1, // 优惠券ID
        //   selected: false, // 是否选择使用该优惠券（发起请求前需要删除该字段！）
        //   couponTicketName: undefined, // 优惠券名称
        //   usableStartTime: 1679129046000, // 可用开始时间
        //   usableEndTime: 1684399446000, // 可用结束时间
        //   ifUsed: 1, // 是否可用：0.否 1.是
        //   status: 0, // 客户优惠券状态：0.可用 1.已使用 2.已过期 3.已作废
        //   logoUrl: undefined, // 优惠券图标
        //   // logoUrl: 'https://fuss10.elemecdn.com/0/6f/e35ff375812e6b0020b6b4e8f9583jpeg.jpeg', // 优惠券图标
        //   // 领取使用规则
        //   receiveUsageRules: {
        //     // 使用条件（门槛）
        //     overlayUseTypes: [], // 优惠叠加
        //     conditionsOfUse: {
        //       useType: 2, // 使用类型：1.无使用门槛 2.订单满多少钱减 3.订单满多少件减
        //       threshold: 168 // 阀值
        //     },
        //     // 适用的商品
        //     applicableProducts: {
        //       applicableType: 1 // 适用商品类型：1.全部商品可用 2.非全部活动商品可用 3.指定商品
        //     },
        //     // 优惠的内容
        //     offerTypeInfo: {
        //       fixedType: 1, // 优惠内容类型：1.固定减价 2.固定折扣
        //       reduction: 98 // 减少量
        //     }
        //   }
        // },
        // {
        //   id: 2, // 优惠券ID
        //   selected: false, // 是否选择使用该优惠券（发起请求前需要删除该字段！）
        //   couponTicketName: undefined, // 优惠券名称
        //   usableStartTime: 1679129046000, // 可用开始时间
        //   usableEndTime: 1684399446000, // 可用结束时间
        //   ifUsed: 1, // 是否可用：0.否 1.是
        //   status: 0, // 客户优惠券状态：0.可用 1.已使用 2.已过期 3.已作废
        //   logoUrl: 'https://fuss10.elemecdn.com/3/28/bbf893f792f03a54408b3b7a7ebf0jpeg.jpeg', // 优惠券图标
        //   // 领取使用规则
        //   receiveUsageRules: {
        //     // 使用条件（门槛）
        //     overlayUseTypes: [], // 优惠叠加
        //     conditionsOfUse: {
        //       useType: 1, // 使用类型：1.无使用门槛 2.订单满多少钱减 3.订单满多少件减
        //       threshold: 100 // 阀值
        //     },
        //     // 适用的商品
        //     applicableProducts: {
        //       applicableType: 2 // 适用商品类型：1.全部商品可用 2.非全部活动商品可用 3.指定商品
        //     },
        //     // 优惠的内容
        //     offerTypeInfo: {
        //       fixedType: 2, // 优惠内容类型：1.固定减价 2.固定折扣
        //       reduction: 15 // 减少量
        //     }
        //   }
        // },
        // {
        //   id: 3, // 优惠券ID
        //   selected: false, // 是否选择使用该优惠券（发起请求前需要删除该字段！）
        //   couponTicketName: undefined, // 优惠券名称
        //   usableStartTime: 1679129046000, // 可用开始时间
        //   usableEndTime: 1684399446000, // 可用结束时间
        //   ifUsed: 0, // 是否可用：0.否 1.是
        //   status: 0, // 客户优惠券状态：0.可用 1.已使用 2.已过期 3.已作废
        //   logoUrl: 'https://fuss10.elemecdn.com/3/28/bbf893f792f03a54408b3b7a7ebf0jpeg.jpeg', // 优惠券图标
        //   // 领取使用规则
        //   receiveUsageRules: {
        //     // 使用条件（门槛）
        //     overlayUseTypes: [], // 优惠叠加
        //     conditionsOfUse: {
        //       useType: 1, // 使用类型：1.无使用门槛 2.订单满多少钱减 3.订单满多少件减
        //       threshold: 100 // 阀值
        //     },
        //     // 适用的商品
        //     applicableProducts: {
        //       applicableType: 2 // 适用商品类型：1.全部商品可用 2.非全部活动商品可用 3.指定商品
        //     },
        //     // 优惠的内容
        //     offerTypeInfo: {
        //       fixedType: 2, // 优惠内容类型：1.固定减价 2.固定折扣
        //       reduction: 15 // 减少量
        //     }
        //   }
        // }
      ],

      payLoading: null,
      logisticsPadding: false,
      seconds: -1,
      paymentAmount: 0, // 支付金额，用于支付成功页面展示
      itemSubtotal: 0, // 项目小计
      shippingSubtotal: 0, // 运费小计
      promotionSubtotal: 0, // 优惠金额小计
      originalPromotionSubtotal: 0, // 优惠金额小计(原始)
      grandTotal: 0, // 总计金额
      originalGrandTotal: 0, // 总计金额(原始)
      selectAddressIndex: -1,
      channelType: undefined, // 运输速度类型

      /**
       * 0：余额支付
       * 1：信用卡支付
       * 2：paypal支付
       */
      paymentMethod: '0', // 支付方式
      orderId: '',
      remark: '',
      productList: [],
      logisticsChannel: [],
      addressForm: {
        fullName: undefined,
        phoneNumber: undefined,
        streetAddressLine1: undefined,
        streetAddressLine2: undefined,
        city: undefined,
        province: undefined,
        countryCode: undefined,
        zipCode: undefined,
        vatCode: undefined
      },
      AddAddressForm: {
        fullName: undefined,
        phoneNumber: undefined,
        streetAddressLine1: undefined,
        streetAddressLine2: undefined,
        city: undefined,
        province: undefined,
        countryCode: undefined,
        zipCode: undefined,
        vatCode: undefined
      },
      mobileActivatedChannel: {}, // 移动端：当前选中的物流渠道

      emailExist: 0,
      isRegister: false, // 是否自动注册
      is_login: false,
      userForm: {
        email: '',
        password: ''
      },
      rules: {
        email: [{ validator: validateEmail, trigger: 'blur' }, { required: true, message: `${this.$t('commodity.ConfirmOrder.Tips1')}`, trigger: 'blur' }],
        password: [{ required: true, message: `${this.$t('commodity.ConfirmOrder.Tips2')}`, trigger: 'blur' }, { min: 6, max: 20, trigger: 'blur', message: `${this.$t('commodity.ConfirmOrder.Tips3')}` }]
      },
      couponCode: undefined, // 优惠码
      couponLoading: false,
      couponInfo: {}, // 优惠码信息
      attachmentSelectedList: [],
      defaultAttachmentsList: [
        'Tags',
        'Bags',
        'Cards'
      ],
      attachmentsList: [],

      paymentId: '', // 付款成功id 交易单id

      // 获取购物车订单预览信息请求参数
      parameter: {
        // 订单商品信息
        products: [
          // {
          //   kkProductId: undefined, // 商品ID
          //   skuCode: undefined, // SKU编码
          //   skuOriginalPriceAmount: undefined, // SKU原价金额
          //   skuQuantity: undefined // SKU数量
          // }
        ],
        couponCode: undefined, // 优惠码
        selectCouponTicketId: undefined, // 客户优惠券ID
        shippingSubtotal: 0 // 总运费
      },

      orderBillingPreviewInfo: {}, // 订单计费预览信息对象

      channelList: [] // 可用的物流渠道列表
    }
  },
  watch: {
    productList: {
      deep: true,
      handler: function(productList) {
        let itemSubtotal = 0
        let shippingSubtotal = 0
        let promotionSubtotal = 0
        productList.forEach(item => {
          shippingSubtotal = math.format(math.evaluate(`${shippingSubtotal}+${item.freightAmount}`))
          item.orderItems.forEach(item => {
            // 商品数量不能小于1 且 不能大于库存数量
            if (item.productNum < 1) item.productNum = 1
            if (item.productNum > item.stock) item.productNum = item.stock
            const price = item.afterDiscountAmount >= 0 ? item.afterDiscountAmount : item.purchasePrices
            itemSubtotal = math.format(math.evaluate(`${itemSubtotal}+${price}*${item.productNum}`))
            if (item.promotionAmount >= 0) {
              promotionSubtotal = math.format(math.evaluate(`${promotionSubtotal}+${item.promotionAmount}*${item.productNum}`))
            }
          })
        })
        this.itemSubtotal = itemSubtotal
        this.shippingSubtotal = shippingSubtotal
        this.promotionSubtotal = promotionSubtotal
        this.originalPromotionSubtotal = promotionSubtotal
        this.grandTotal = math.format(math.evaluate(`${itemSubtotal}+${shippingSubtotal}`))
        this.originalGrandTotal = math.format(math.evaluate(`${itemSubtotal}+${shippingSubtotal}`))
        // 当输入了优惠码时，改变产品数量重新校验优惠码
        if (this.couponCode) {
          this.couponApply()
        }
      }
    },
    grandTotal(val) {
      if (+val <= 0) {
        this.paymentMethod = '0'
      }
    },
    '$route'(to, from) {
      this.init()
    }
  },
  computed: {
    /**
     * 优惠券模块 - 获取已选中的优惠券的优惠类型
     */
    getOfferTypePrice() {
      return this.coupon.receiveUsageRules && this.coupon.receiveUsageRules.offerTypeInfo && this.coupon.receiveUsageRules.offerTypeInfo.fixedType ? this.coupon.receiveUsageRules.offerTypeInfo.fixedType : undefined
    },

    /**
     * 获取可用和不可用的优惠券列表
     */
    getCouponListByStatus() {
      return (ifUsed) => {
        if (this.coupons.length) {
          if (ifUsed === 0) {
            return this.coupons.filter((column) => column.ifUsed === 0)
          } else {
            return this.coupons.filter((column) => column.ifUsed === 1)
          }
        } else {
          return []
        }
      }
    },

    /**
     * 优惠券模块 - 获取可用优惠券的数量
     */
    getAvailableCouponQuantity() {
      let quantity = 0
      if (this.coupons.length) {
        this.coupons.forEach((coupon) => {
          if (coupon.status === 0 && coupon.ifUsed === 1) {
            quantity += 1
          }
        })
      }
      return quantity
    },

    addressList() {
      let address = this.$store.state.common.addressList
      if (!address.length) this.$store.dispatch('common/getAddressList')
      return address
    },
    balance() {
      return +this.$store.state.common.balance
    },
    // 移动端：商品列表第一个商品对象
    firstProduct() {
      return this.productList[0] || {}
    },
    payCallbackUrl() {
      return `${location.origin}/payment-status?state=success&orderId=${this.orderId}&paymentMethod=${this.paymentMethod}&paymentAmount=${this.paymentAmount}`
    },
    payoneerCallbackUrl() {
      return `${location.origin}/payment-status?orderId=${this.orderId}`
    },
    countryCode() {
      let countryCode = 'US'
      if (this.addressList.length) {
        countryCode = this.addressList[this.selectAddressIndex].countryCode
      }
      return countryCode
    },
    userId() {
      return this.$store.state.common.userId
    }
  },
  created() {
    // const confirmOrderLogin = localStorage.getItem('confirmOrderLogin')
    // if (confirmOrderLogin) {
    //   localStorage.removeItem('confirmOrderLogin')
    //   const cartParams = this.$store.state.common.cartList.map(item => ({
    //     warehouseCode: item.warehouseCode,
    //     skuCode: item.skuCode,
    //     kkProductId: item.kkProductId,
    //     num: item.num
    //   }))
    //   API.addBatchCart({ cartParams }).then(result => {
    //     bus.$emit('getCartList')
    //     this.getCartList(this.$route.query.kkProductId.split(','))
    //   })
    //   return
    // }
    this.init()
    this.getProductAttachments()
    // 抖音数据埋点
    window.ttq && window.ttq.track('AddPaymentInfo')
  },
  methods: {
    /**
     * API 获取购物车订单预览信息
     */
    async getOrderBillingPreviewInfo() {
      let { code, message, data } = await API.getOrderBillingPreviewInfo(this.parameter)
      if (code === 10000) {
        this.orderBillingPreviewInfo = data
        this.coupons = data.orderBillingFilterResults.couponTicketInfos || [] // 获取优惠券
        if (this.coupons && this.coupons.length) {
          this.coupons.forEach((item) => {
            if (item.id === this.coupon.id) {
              if (item.ifUsed === 1) {
                item.selected = true
              } else {
                item.selected = false
                this.coupon = {}
              }
            } else {
              item.selected = false
            }
          })
        } else {
          this.coupon = {}
        }
        // 关闭展开框
        this.showVantPopup = false
        this.checkBalance()
      } else {
        // 关闭展开框
        this.showVantPopup = false
        this.$message.error(message)
      }
    },
    checkBalance() {
      let transactionTotalAmount = this.orderBillingPreviewInfo.transactionTotalAmount || 0
      this.balance < transactionTotalAmount || this.balance === 0 ? (this.$store.state.common.userGroup === 100 ? this.paymentMethod = 4 : this.paymentMethod = 9) : this.paymentMethod = 0
    },
    quantityChange(quantity) {
      this.getAllLogisticsChannel()
    },

    /**
     * 优惠券模块 - 点击选择优惠券的回调事件
     */
    onClickSelectCoupon() {
      this.showVantPopup = true
    },

    /**
     * 优惠券模块 - 点击某个优惠券时触发的事件
     *
     * @param {Number} id 当前点击的优惠券ID
     */
    onClickCoupon(id) {
      this.coupons.forEach((item) => {
        if (item.id === id) {
          item.selected = !item.selected
          if (item.selected) {
            this.coupon = _.cloneDeep(item)
          } else {
            this.coupon = {}
          }
        } else {
          item.selected = false
        }
      })
      this.parameter.selectCouponTicketId = this.coupon.id // 优惠券ID
      // 调用接口获取购物车订单预览信息
      this.getOrderBillingPreviewInfo()
    },

    // 页面初始化
    init() {
      this.$store.dispatch('common/getBalance')
      this.getCartList(this.$route.query.skuCode.split(','))
    },
    getCartList(skuCode) {
      // if (!this.userId) {
      //   const cartList = this.$store.state.common.cartList
      //   let arr = []
      //   cartList.forEach(item => {
      //     if (skuCode.includes(item.skuCode + '')) {
      //       arr.push(item)
      //     }
      //   })
      //   this.formatProductList(arr)
      //   this.getSelectAddressIndex()
      //   return
      // }
      API.getCartList({ kkProductIds: this.$route.query.kkProductId.split(','), skuCodes: this.$route.query.skuCode.split(',') }).then(result => {
        result.data.forEach(item => {
          // 将option字符串保存一下，创建订单的时候要用
          item.option1String = item.option1
          item.option2String = item.option2
          try {
            item.option1 = JSON.parse(item.option1)
            item.option2 = JSON.parse(item.option2)
          } catch (error) {
            console.log(error)
            item.option1 = item.option2 = {}
          }
        })
        this.formatProductList(result.data)
        this.getSelectAddressIndex()
      })
    },
    getSelectAddressIndex() {
      if (!this.userId) {
        this.selectAddressIndex = 0
        this.getAllLogisticsChannel()
        return
      }
      if (this.addressList.length > 0) {
        const index = this.addressList.findIndex(item => +item.isDefault === 1)
        this.selectAddressIndex = index > -1 ? index : 0
        this.getAllLogisticsChannel()
      }
    },
    getAddressList(address) {
      if (!this.userId) {
        this.$refs.addressdialog._data.dialogVisible = false
        this.$refs.addressdialog._data.loading = false
        this.addressList.push(address)
        this.getSelectAddressIndex()
        return
      }
      this.$store.dispatch('common/getAddressList').then(() => {
        this.getSelectAddressIndex()
      })
    },
    getAllLogisticsChannel() {
      // if (this.isOverWeight()) return this.$message.info(this.$t('promptText.msg6'))
      this.logisticsPadding = true
      const params = {
        warehouses: []
      }
      this.productList.forEach(item => {
        params.warehouses.push({
          warehouseId: item.warehouseId,
          warehouseCode: item.warehouseCode,
          termini: this.addressList[this.selectAddressIndex].countryCode,
          zipCode: this.addressList[this.selectAddressIndex].zipCode,
          channelGrouping: item.channelGrouping,
          products: item.orderItems.map(item => {
            return {
              price: item.purchasePrices,
              skuCode: item.skuCode,
              quantity: item.productNum,
              kkProductId: item.kkProductId
            }
          })
        })
      })
      if (params.warehouses.length !== 0) {
        API.getLogisticsChannel(params).then(result => {
          try {
            this.orderBillingPreviewInfo.shippingSubtotal = 0
            this.orderBillingPreviewInfo.couponCodeTotalAmoun = 0
            this.orderBillingPreviewInfo.couponTicketTotalAmount = 0
            this.orderBillingPreviewInfo.transactionTotalAmount = 0
            this.$set(this, 'mobileActivatedChannel', {})
            this.channelList = result.data[0].data
            const logisticsChannel = result.data.map(item => item.data)
            logisticsChannel.forEach((item, index) => {
              if (item.length === 0) throw new Error('The current shipping location cannot deliver to this address, please change the shipping address or shipping location')

              // 计算每一条渠道的天数
              item.map(item => {
                item.deliveryDayNum = +item.deliveryTime.split('~')[0]
              })
              this.productList[index].logisticsChannel = item
              // const StandardChannel = _.maxBy(item, item => +item.deliveryDayNum) // 9月以前逻辑
              // const StandardChannel = item.length === 1 ? item[0] : item[1]
              const StandardChannel = item[0] // 手机版本默认 快速
              this.$set(this.productList[index], 'freightAmount', StandardChannel.estimatedFreight)
              this.$set(this.productList[index], 'channelCode', StandardChannel.channelCode)
              this.isPC ? this.$refs.channelSelectionDialog[0].setDefaultChannelCode(StandardChannel.channelCode) : this.$refs.channelSelectionDialog.setDefaultChannelCode(StandardChannel.channelCode)
              this.$set(this, 'mobileActivatedChannel', StandardChannel)
            })

            this.parameter.products = [] // 订单商品信息
            params.warehouses.forEach((products) => {
              products.products.forEach((product) => {
                if (Number.parseInt(product.quantity) > 0) {
                  this.parameter.products.push({
                    kkProductId: product.kkProductId, // 商品ID
                    skuCode: product.skuCode, // SKU编码
                    skuOriginalPriceAmount: product.price, // SKU原价金额
                    skuQuantity: Number.parseInt(product.quantity) // SKU数量
                  })
                }
              })
            })

            if (this.channelList.length >= 2) {
              this.channelList.forEach((item) => {
              // if (item.agingGrade === 'Standard') {
                if (item.agingGrade === 'Express') {
                  this.parameter.shippingSubtotal = item.estimatedFreight // 总运费
                  this.channelType = item.agingGrade
                }
              })
            } else {
              this.parameter.shippingSubtotal = this.channelList[0].estimatedFreight // 总运费
              this.channelType = this.channelList[0].agingGrade
            }

            // this.parameter.selectCouponTicketId = undefined // 已选择的优惠券失效
            // 调用接口获取购物车订单预览信息
            this.getOrderBillingPreviewInfo()
          } catch (error) {
            this.getFreightFailCallBack()
            console.log(error)
          }
        }).finally(() => {
          this.logisticsPadding = false
        })
      }
    },
    /**
     * 当获取运费失败时，重置运费为0
     */
    getFreightFailCallBack() {
      this.productList.forEach(item => {
        this.$set(item, 'freightAmount', 0.00)
      })
      this.$message.info(this.$t('promptText.msg9'))
    },
    /**
     * 获取单个物流渠道列表
     * 这个接口会比较慢，当接口响应成功后，productList中的元素可能发生了改变，导致更新物流渠道和运费错误！！！
     * product: 商品对象
     */
    getLogisticsChannel: _.debounce(function(index, product) {
      if (this.isOverWeight()) {
        this.$set(product, 'productNum', this.getAvailableProductMaxQuantity(product))
      }
      this.logisticsPadding = true
      const item = this.productList[index]
      const params = {
        warehouses: [{
          warehouseId: item.warehouseId,
          warehouseCode: item.warehouseCode,
          termini: this.addressList[this.selectAddressIndex].countryCode,
          channelGrouping: item.channelGrouping,
          products: item.orderItems.map(item => {
            return {
              skuCode: item.skuCode,
              quantity: item.productNum,
              kkProductId: item.kkProductId
            }
          })
        }]
      }
      API.getLogisticsChannel(params).then(result => {
        try {
          const channel = result.data[0].data
          const productIndex = this.productList.findIndex(product => product.warehouseCode === item.warehouseCode)
          if (productIndex === -1) return
          const product = this.productList[productIndex]
          this.$set(product, 'logisticsChannel', channel)
          const channelIndex = channel.findIndex(cha => product.channelCode === cha.channelCode)
          if (channelIndex > -1) {
            // 更新渠道列表之后，有可能渠道是一样的，但是运费一定不一样，所有需要更新运费
            this.$set(product, 'freightAmount', channel[channelIndex].estimatedFreight)
            return
          }
          // 使用最小运费的渠道
          const minChannel = _.minBy(channel, item => +item.estimatedFreight)
          this.$set(product, 'channelCode', minChannel.channelCode)
          this.$set(product, 'freightAmount', minChannel.estimatedFreight)
        } catch (error) {
          console.error(error)
        }
      }).catch(() => {
        console.error('The current shipping location cannot deliver to this address, please change the shipping address or shipping location')
      }).finally(() => {
        this.logisticsPadding = false
      })
    }, 1000, { leading: false, trailing: true }),
    /**
     * 商品总重量加起来不超过30kg
     */
    isOverWeight() {
      let weight = 0
      this.productList.forEach(item => {
        item.orderItems.forEach(item => {
          weight += (+item.packageWeight * +item.productNum)
        })
      })
      return weight > PRODUCT_MAX_WEIGHT
    },
    /**
     * 获取一个商品能购买的最大数量（不超重，不超库存）
     */
    getAvailableProductMaxQuantity(product) {
      let ortherProductWeight = 0
      let availableProductMaxQuantity = 0
      this.productList.forEach(item => {
        item.orderItems.forEach(item => {
          if (+item.id !== +product.id) {
            ortherProductWeight += +item.productNum * +item.packageWeight
          }
        })
      })
      availableProductMaxQuantity = ~~((PRODUCT_MAX_WEIGHT - +ortherProductWeight) / +product.packageWeight)
      if (availableProductMaxQuantity > +product.stock) availableProductMaxQuantity = +product.stock
      return availableProductMaxQuantity
    },
    formatProductList(productList) {
      const productMap = {}
      productList.forEach(item => {
        // 原有逻辑：根据仓库id进行分组
        // if (!productMap[item.warehouseCode]) {
        //   productMap[item.warehouseCode] = {
        //     freightAmount: 0, // 运费
        //     orderItems: [],
        //     warehouseId: item.warehouseId,
        //     warehouseCode: item.warehouseCode, // 仓库编码
        //     channelGrouping: item.warehouseType, // 仓库类型
        //     countryCode: item.countryCode, // 发货国家
        //     shipFromText: `${item.countryCn} - ${item.warehouseName}`
        //   }
        // }
        if (!productMap['custom']) {
          // 特殊需求，中国仓库写死仓库id，编码，类型
          const inChina = ['CN_S', 'CN_N'].includes(item.countryCode)
          productMap['custom'] = {
            freightAmount: 0, // 运费
            orderItems: [],
            warehouseId: inChina ? 13 : item.warehouseId,
            warehouseCode: inChina ? 'G007' : item.warehouseCode, // 仓库编码
            channelGrouping: inChina ? 1 : item.warehouseType, // 仓库类型
            countryCode: item.countryCode, // 发货国家
            // shipFromText: `${item.countryCn} - ${inChina ? 'warehouse13' : item.warehouseName}`
            shipFromText: `${item.countryCn}`
          }
        }
        productMap['custom'].orderItems.push({
          id: item.id,
          cartId: item.cartId,
          kkProductId: item.kkProductId,
          productName: item.skuName,
          productNum: item.num,
          purchasePrices: item.price,
          option1: item.option1String,
          option2: item.option2String,
          color: item.option1.value,
          size: item.option2.value,
          skuCode: item.skuCode,
          sizeImagePath: item.imgUrl,
          itemNo: item.spuCode,
          stock: item.stock,
          packageWeight: item.packageWeight,
          discountId: item.discountId, // 促销活动ID
          afterDiscountAmount: item.afterDiscountAmount, // 折后价
          promotionAmount: item.promotionAmount // 优惠金额
        })
      })
      this.productList = Object.values(productMap)
    },
    deleteProduct(index1, index2) {
      if (this.productList.length === 1 && this.productList[0].orderItems.length === 1) return
      this.$delete(this.productList[index1].orderItems, index2)
      if (this.productList[index1].orderItems.length === 0) {
        return this.$delete(this.productList, index1)
      }
      this.getLogisticsChannel(index1)
    },
    /**
     * 点击支付（Proceed to Checkout）按钮
     */
    clickPay() {
      // google 埋点 付款埋点
      window.gtag('event', 'proceed_to_checkout')
      window.gtag('event', 'pay_now')
      // window.gtag('event', 'proceed_to_checkout', { 'send_to': 'G-4335ZYH2TJ' })
      // window.gtag('event', 'pay_now', { 'send_to': 'G-4335ZYH2TJ' })
      // 抖音数据埋点
      window.ttq && window.ttq.track('InitiateCheckout')

      if (this.logisticsPadding || +this.shippingSubtotal === 0) return this.$message.info(this.$t('promptText.msg9'))
      if (+this.paymentMethod === 0 && this.balance < this.grandTotal) return this.$message.info(this.$t('promptText.msg11'))
      if (this.addressList.length === 0) return this.$message.info(this.$t('promptText.msg12'))
      if (this.selectAddressIndex === -1) return this.$message.info(this.$t('promptText.msg13'))

      // 取消邮箱校验
      // if (this.$store.state.common.isAuthentication === false) {
      //   bus.$emit('openVerifiedEmailDialog')
      // } else {
      //   this.createOrder()
      // }

      if (!this.userId && !checkEmail(this.userForm.email)) {
        this.$message.warning(this.$t('promptText.msg14'))
        return
      }

      if (!this.userId && this.isRegister && this.emailExist) {
        this.$message.warning(this.$t('promptText.msg15'))
        return
      }

      // 如果是游客下单先获取游客token
      if (!this.userId) {
        this.getVisitorToken()
        return
      }
      this.createOrder()
    },
    /**
     * 创建订单
     */
    createOrder() {
      this.shippingSubtotal = this.orderBillingPreviewInfo.shippingSubtotal
      this.grandTotal = this.orderBillingPreviewInfo.transactionTotalAmount
      if (this.orderBillingPreviewInfo.couponTicketTotalAmount) {
        this.promotionSubtotal = (this.promotionSubtotal + this.orderBillingPreviewInfo.couponTicketTotalAmount).toFixed(2)
      }
      const addr = this.addressList[this.selectAddressIndex]
      const orderAddresses = {
        country: addr.countryCode,
        city: addr.city,
        phone: addr.phoneNumber,
        recipient: addr.fullName,
        street1: addr.streetAddressLine1,
        street2: addr.streetAddressLine2,
        province: addr.province,
        zip: addr.zipCode,
        vat: addr.vatCode,
        ioss: addr.ioss
      }
      const params = {
        selectCouponTicketId: this.parameter.selectCouponTicketId,
        channelType: this.channelType,
        orderAddresses,
        order: _.cloneDeep(this.productList),
        remark: this.remark,
        paymentMethod: +this.paymentMethod === 4 ? 3 : this.paymentMethod,
        itemSubtotal: this.itemSubtotal,
        shippingSubtotal: this.shippingSubtotal,
        grandTotal: this.grandTotal,
        promotionSubtotal: this.promotionSubtotal || undefined,
        cartIds: []
      }
      if (!this.userId) {
        params.orderType = 1
        params.expandField = this.userForm.email
        params.isRegister = this.isRegister ? 1 : 0
      }
      // 优惠码
      if (this.couponInfo.message && !this.couponInfo.error) {
        params.couponCode = this.couponInfo.couponCode
      }
      this.productList.forEach(item => {
        item.orderItems.forEach(item => {
          params.cartIds.push(item.id)
        })
      })
      params.order.forEach(item => {
        delete item.visible
        delete item.shipFromText
        delete item.logisticsChannel
        item.orderItems.forEach(item => {
          delete item.size
          delete item.color
          delete item.stock
        })
      })
      if (this.isPC) {
        this.payLoading = this.$loading.service({
          lock: true,
          text: 'Payment Pending',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)',
          customClass: 'el-loading-spinner-box'
        })
      } else this.payLoading = this.$loading.service()
      const attachmentSkus = this.attachmentSelectedList.map(type => {
        return this.attachmentsList.find(e => e.type === type).skuCode
      })
      params.attachmentSkus = attachmentSkus
      API.createOrder(params).then(result => {
        // if (result.code !== 10000) return this.$message.error(result.message)
        this.createTransactionOrder(this.grandTotal, this.paymentMethod, result.data)
        this.orderId = result.data.join('，')
        // this.gtag(params, result.data[0])

        // 抖音数据埋点
        window.ttq && window.ttq.track('PlaceAnOrder')
      }).catch(response => {
        this.$message.error(response.data.message)
      }).finally(() => {
        bus.$emit('getCartList')
        this.payLoading.close()
      })
    },
    /**
     * 创建交易单
     * amount 订单总金额
     * paymentMethod  支付方式
     * kkOrderIds<Array> 订单id [orderId<String,Number>, ...]
     */
    createTransactionOrder(amount, paymentMethod, kkOrderIds) {
      API.createTransactionOrder({
        amount,
        paymentMethod: +paymentMethod === 4 ? 3 : paymentMethod,
        currencyCode: 'USD',
        paymentType: 0,
        kkOrderIds
      }).then(result => {
        this.paymentAmount = amount
        const addr = this.addressList[this.selectAddressIndex]
        const product = this.productList[0].orderItems[0]
        this.paymentId = result.data
        switch (+this.paymentMethod) {
          case 0:
            this.balancePayment(result.data)
            break
          case 1:
            this.payLoading.close()
            this.$refs.qianhai.show({
              order_number: result.data, // 订单号
              order_amount: amount, // 交易金额
              billing_lastName: addr.fullName, // 持卡人名
              billing_firstName: addr.fullName, // 持卡人姓
              billing_email: this.$store.state.common.email, // 持卡人邮箱
              billing_country: addr.countryCode, // 持卡人国家
              billing_state: addr.province, // 持卡人州/省
              billing_city: addr.city, // 持卡人城市
              billing_address: addr.streetAddressLine1, // 持卡人地址
              billing_zip: addr.zipCode, // 持卡人邮编
              productName: product.productName, // 产品名称
              productNum: product.productNum, // 数量
              productSku: product.skuCode
            })
            break
          case 2:
            this.payLoading.close()
            this.$refs.paypal.show(result.data)
            break
          case 3:
            this.payLoading.close()
            this.$refs.airwallex.show(result.data, ['wechatpay', 'alipaycn'])
            break
          case 4:
            this.payLoading.close()
            this.$refs.airwallex.show(result.data, ['card'])
            break
          case 9:
            this.payLoading.close()
            this.$refs.payoneer.show(result.data)
            break
        }
      }).catch(() => {
        this.payLoading.close()
      })
    },
    /**
     * 余额付款
     */
    balancePayment(paymentId) {
      API.balancePayment(paymentId).then(result => {
        this.paySuccess()
      }).finally(() => {
        this.payLoading.close()
      })
    },
    /**
     * 支付成功
     */
    paySuccess: function() {
      // 谷歌电子商务 购买埋点
      gtagReport(this.paymentId)
      // 余额付款成功，刷新余额
      if (+this.paymentMethod === 0) this.$store.dispatch('common/getBalance')
      this.$router.replace({
        path: '/payment-status',
        query: {
          state: 'success',
          orderId: this.orderId,
          paymentTime: dateFormat(),
          paymentMethod: this.paymentMethod,
          paymentAmount: this.paymentAmount
        }
      })
      this.clearToken()
      this.rdt()
    }.after(() => {
      window.ttq && window.ttq.track('CompletePayment')
    }),
    /**
     * 支付失败
     */
    payFail(error) {
      this.clearToken()
      this.$message.error(error.message || this.$t('orderDetail.payFail'))
      this.$router.replace({
        path: '/payment-status',
        query: {
          state: 'fail',
          orderId: this.orderId
        }
      })
    },
    /**
     * 取消支付
     */
    payCancel() {
      if (!this.userId) this.clearToken()
      this.$router.push('/order/list')
    },
    // 清除游客token
    clearToken() {
      !this.userId && this.$store.commit('common/set', { token: '' })
    },
    addressIndexChange(index) {
      if (index === this.selectAddressIndex) return
      this.selectAddressIndex = index
      this.getAllLogisticsChannel()
    },
    addAddressdialog() {
      this.$set(this, 'addressForm', this.AddAddressForm)
      this.$refs.addressdialog.show()
    },
    editAddress(address) {
      this.$set(this, 'addressForm', address)
      this.$refs.addressdialog.show()
    },
    channelChange(channel, index) {
      this.channelList.forEach((item) => {
        if (item.channelCode === channel.channelCode) {
          // this.channelType = item.agingGrade
          // this.shippingSubtotal = item.estimatedFreight // 总运费
          this.parameter.shippingSubtotal = item.estimatedFreight // 总运费
          this.channelType = item.agingGrade
        }
      })
      // 调用接口获取购物车订单预览信息
      this.getOrderBillingPreviewInfo()

      const product = this.productList[index]
      this.$set(product, 'channelCode', channel.channelCode)
      this.$set(product, 'freightAmount', channel.estimatedFreight)
      this.$set(product, 'visible', false)
      this.$set(this, 'mobileActivatedChannel', channel)
    },
    logoutSignUp() {
      if (!this.isRegister) {
        return
      }
      if (!checkEmail(this.userForm.email)) {
        this.$message.warning(this.$t('promptText.msg14'))
        return
      }
      // if (this.userForm.password.length < 6 || this.userForm.password.length > 20) {
      //   this.$message.warning('Please enter a password of 6 to 20 characters')
      //   return
      // }
      let password = encrypt(randomString(6))
      API.logoutSignUp({
        email: this.userForm.email,
        password: password,
        fullName: this.userForm.email
      }).then(({ data }) => {
        if (!data || !data.code || data.code === 10504) {
          this.$store.commit('common/set', { fastLogin: true })
          this.login(password)
          return
        }
        if (data.code) {
          this.$message.error(data.message)
          return
        }
      })
    },
    login(password) {
      let data = new FormData()
      data.append('grant_type', 'password')
      data.append('client_id', 'client_general')
      data.append('client_secret', 'genera_secret')
      data.append('username', this.userForm.email)
      // data.append('password', encrypt(this.userForm.password))
      data.append('password', password)
      API.login(data).then((result) => {
        this.is_login = true
        this.loginSuccessCb(result)
      }).catch(result => {
        this.$message.error(result.data.message)
        this.$store.commit('set', { fastLogin: false })
      }).finally(() => {
      })
    },
    // 获取用户邮箱是否已认证
    getEmailStatus() {
      this.is_login = true
      API.getEmailStatus().then(result => {
        this.$store.commit('common/set', { isAuthentication: +result.data === 1 })
      })
    },
    showAddressdialog() {
      this.$refs.addressdialog.show()
      // if (this.$store.state.common.userId) {
      //   this.$refs.addressdialog.show()
      // } else {
      //   this.$message.warning('Please fill in your email address')
      // }
    },
    jumpLogin() {
      localStorage.setItem('loginRedirection', JSON.stringify({
        path: this.$router.app._route.path,
        query: this.$router.app._route.query
      }))
      this.$router.push('/login')
    },
    // 获取游客token
    getVisitorToken() {
      API.getVisitorToken().then(({ data }) => {
        this.$store.commit('common/set', { token: data })
        this.createOrder()
      })
    },
    // 验证邮箱是否存在
    authEmailExist() {
      if (!this.isRegister && !checkEmail(this.userForm.email)) {
        this.$message.warning(this.$t('promptText.msg14'))
        return
      }
      API.authEmailExist({ email: this.userForm.email }).then(({ data }) => {
        this.emailExist = data
        if (data) {
          this.$message.warning(this.$t('promptText.msg15'))
        }
      })
    },
    // // 增强型电子商务代码
    // gtag(data, transaction_id) {
    //   try {
    //     window.gtag('event', 'purchase', {
    //       transaction_id,
    //       value: data.itemSubtotal,
    //       currency: 'USD',
    //       shipping: data.shippingSubtotal,
    //       items: data.order[0].orderItems.map(item => ({
    //         id: item.kkProductId,
    //         name: item.productName,
    //         quantity: item.productNum,
    //         price: item.purchasePrices
    //       }))
    //     })
    //   } catch (error) {
    //     console.error(error)
    //   }
    // },
    // 获取优惠码
    couponApply() {
      if (!this.couponCode) {
        this.$message.warning(this.$t('promptText.msg16'))
        return
      }
      if (!this.userId && !this.userForm.email) {
        this.$message.warning(this.$t('promptText.msg14'))
        return
      }
      this.couponLoading = true
      const param = {
        couponCode: this.couponCode,
        // userEmail: !this.userId ? this.userForm.email : undefined,
        hasOtherDiscount: false,
        productNum: 0,
        transactionAmount: this.originalGrandTotal,
        maxProductAmount: 0
      }
      this.productList[0].orderItems.forEach(item => {
        param.productNum += +item.productNum
        if (item.afterDiscountAmount) {
          param.hasOtherDiscount = true
        }
        if ((item.afterDiscountAmount ? item.afterDiscountAmount : item.purchasePrices) > param.maxProductAmount) {
          param.maxProductAmount = (item.afterDiscountAmount ? item.afterDiscountAmount : item.purchasePrices)
        }
      })
      this.couponInfo = {}
      this.promoCodeMessage = undefined
      API.couponCodeCheck(param).then(res => {
        if (res.code === 10000) {
          let data = res.data || {}
          data.message = res.message
          this.$set(this.$data, 'couponInfo', data)
          this.grandTotal = data.transactionAmount + ''
          this.promotionSubtotal = _.round(+this.originalPromotionSubtotal + data.discountAmount, 2)
        } else {
          this.promoCodeMessage = res.message
        }

        // 获取优惠码
        this.parameter.couponCode = this.couponInfo.couponCode
        // 调用接口获取购物车订单预览信息
        this.getOrderBillingPreviewInfo()
      }).catch(({ data }) => {
        this.$set(this.couponInfo, 'message', (!data.message || (data.message && data.message.length) > 200) ? 'system exception' : data.message)
        this.$set(this.couponInfo, 'error', true)
      }).finally(() => {
        this.couponLoading = false
      })
    },
    clearCouponCode() {
      this.promoCodeMessage = undefined
      if (this.couponCode.length !== 0) {
        return
      }
      this.couponInfo = {}
      // 改变 productList的值 手动触发 watch更新
      this.$set(this.productList[0], 'change', !this.productList[0].change)

      this.parameter.couponCode = undefined
      // 调用接口获取购物车订单预览信息
      this.getOrderBillingPreviewInfo()
    },
    // reddit 数据埋点
    rdt() {
      let itemCount = _.sumBy(this.productList[0].orderItems, 'productNum')
      window.rdt && window.rdt('track', 'Purchase', {
        currency: 'USD', itemCount, transactionId: this.orderId, value: this.paymentAmount
      })
    },
    // 用户配件列表
    getProductAttachments() {
      // API.getProductAttachments(this.kkOrderId).then(res => {
      API.getNewProductAttachments().then(res => {
        const attachments = res.data
        // 使用 reduce 方法对 type 进行去重
        const uniqueAttachmentsList = attachments.reduce((uniqueList, currentItem) => {
          const existingItem = uniqueList.find(item => item.type === currentItem.type)

          // 如果当前 type 在去重后的数组中不存在，就添加到数组中
          if (!existingItem) {
            uniqueList.push({
              imageUrl: currentItem.imageUrl,
              name: currentItem.name,
              type: currentItem.type,
              skuCode: currentItem.skuCode
              // 这里可以根据实际情况选择保留其他属性
            })
          }

          return uniqueList
        }, [])

        // 将去重后的数组赋值给组件的 attachmentsList
        this.attachmentsList = uniqueAttachmentsList
        this.attachmentSelectedList = this.attachmentsList.map(t => t.type)
      })
    },
    putProductAttachments() {
      return new Promise((resolve, reject) => {
        // 判断配件勾选状态与最初状态是否有更改，区分出新增的与删除的
        const initialAttachments = this.product.orderItems[0].attachmentSkuVos.map(e => {
          return {
            kkItemId: e.kkItemId,
            kkOrderId: e.kkOrderId,
            skuCode: e.skuCode,
            name: e.name,
            imageUrl: e.imageUrl,
            type: e.type,
            id: e.id
          }
        })
        // 新增的
        let attachmentItemsAdd = this.attachmentSelectedList.map(e => {
          return this.attachmentsList.find(ee => ee.type === e)
        }).map(e => e.skuCode)
        // 删除的
        let attachmentItemsDelete = initialAttachments.filter(e => this.attachmentSelectedList.every(type => type !== e.type))
        if (!attachmentItemsAdd.length && !attachmentItemsDelete.length) {
          resolve()
          return
        }
        const params = {
          addOrderAttachments: [],
          deleteOrderAttachments: [
            {
              kkOrderId: this.kkOrderId,
              attachmentItems: attachmentItemsDelete.map(e => ({ id: e.id }))
            }
          ]
        }
        if (attachmentItemsAdd.length) {
          const attachmentItems = this.orderInfo.orderItems.map(e => {
            return {
              kkItemId: e.kkItemId,
              skuCodes: attachmentItemsAdd
            }
          }).filter(e => e.skuCodes.length)
          params.addOrderAttachments = [
            { kkOrderId: this.kkOrderId, attachmentItems }
          ]
        }
        API.putProductAttachments(params).then(res => {
          console.log('done')
          resolve()
        })
      })
    }
  }
}
</script>

<style>
.mobile-address-list-popover {
  max-height: 70vh;
  overflow-y: auto;
}
.el-loading-spinner-box .el-loading-spinner{
  width: 420px;
  height: 155px;
  background: #fff;
  top: calc(50% - 77px);
  left: calc(50% - 210px);
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
}
.el-loading-spinner-box .el-icon-loading{
  font-size: 30px;
  margin-right: 16px;
}
</style>
<style lang="scss" scoped>
.title {
  color: #10141D;
  font-size: 16px;
}

.van-tabs {
  height: calc(100% - 37px);
}

/deep/.van-tabs__content {
  height: calc(100% - 44px);
}

/deep/.van-tabs__wrap {
  border-bottom: 1px solid #CDD4DD;
}

/deep/.van-tabs__line {
  background-color: #99C41C;
}

/deep/.van-tab__pane {
  padding: 12px 18px;
  height: 100%;
  overflow: auto;
}

.car-coupons-ul {
  display: grid;
  grid-gap: 12px 12px;
  justify-content: center;
  grid-template-columns: repeat(auto-fill, 100%);

  -ms-overflow-style: none;
  overflow: -moz-scrollbars-none;
  &::-webkit-scrollbar {
    width: 0 !important;
  }
}

.not-data {
  display: flex;
  width: 100%;
  height: 100%;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  img {
    width: 60%;
  }
  .tips-text {
    color: #747a87;
    font-size: 14px;
    margin-top: 18px;
  }
}

.content {
  .left {
    .account{
      width: 834px;
      padding: 15px 21px 20px 28px;
      margin-bottom: 10px;
      h3 {
        font-weight: 500;
        font-size: 18px;
        line-height: 27px;
        padding-bottom: 12px;
      }
      .text {
        width: 626px;
        span {
          color: #99C41C;
          padding-left: 10px;
        }
      }
    }

    .address {
      width: 834px;
      box-shadow: 0px 4px 14px 6px rgba(205, 212, 221, 0.1);
      padding: 15px 21px 15px 28px;
      margin-bottom: 1px;
      h3 {
        font-weight: 500;
        font-size: 18px;
        line-height: 27px;
        padding-bottom: 12px;
      }
      .add-address {
        width: 182px;
        height: 36px;
        border-radius: 100px;
        font-size: 14px;
        padding: 0 20px;
      }
      .select-another-address {
        position: absolute;
        top: 21px;
        right: 21px;
        font-size: 14px;
        color: #99c41c;
      }

      .current-address {
        font-size: 14px;
        color: #8b93a3;
      }
    }
    .remark {
      padding: 15px 23px;
      white-space: nowrap;
      /deep/.el-input__inner {
        border-radius: 30px;
      }
    }
    .product-block {
      padding: 15px 20px;
      /deep/.el-input__inner {
        border-radius: 30px;
        height: 36px;
        width: 98px;
      }
      .top {
        height: 56px;
        .shipping {
          width: 167px;
          height: 36px;
          border: 0.5px solid #cdd4dd;
          border-radius: 40px;
          padding: 0 14px;
          color: #10141d;
        }
      }
      .discount-price{
        font-weight: 500;
        font-size: 16px;
        color: #A6100C;
      }
      .original-price{
        font-weight: 400;
        font-size: 14px;
        color: #747A87;
        padding: 0 15px 0 10px;
        text-decoration: line-through;
      }
    }
  }
  .right {
    width: 353px;
    .top {
      padding: 16px 12px;
      margin-bottom: 10px;
      .title {
        font-size: 18px;
      }
      .coupon-code {
        margin: 10px 0;
        height: 36px;
        border-radius: 30px;
        border: 1px solid #CDD4DD;
        position: relative;
        .coupon-code-input{
          width: 76%;
          /deep/.el-input__inner {
            height: 34px;
            border: unset;
          }
        }
        .coupon-code-btn{
          height: 100%;
          border-radius: 30px;
          position: absolute;
          right: 0;
          line-height: 14px;
        }
      }
      .coupon-bar {
        width: 290px;
        height: 32px;
        border: 0.5px solid #E3444E;
        background: rgba(227, 68, 78, 0.03);
        border-radius: 4px;
        margin: 0 auto;
        margin-top: 10px;
      }
      .icon-a-close-line1 {
        border-radius: 50%;
        border: .5px solid #E3444E;
        font-size:16px;
        margin-right:6px;
      }
      .success {
        color: #99C41C;
      }
      .error {
        color: #E3444E;
      }
    }
    .total-payable {
      padding: 15px 25px;
      margin-bottom: 1px;
      h3 {
        font-weight: 500;
        font-size: 18px;
        line-height: 27px;
      }
      p {
        padding-top: 15px;
        span:first-child {
          font-weight: 500;
          font-size: 14px;
          line-height: 21px;
          color: #747a87;
        }
        span:last-child {
          font-weight: 500;
          font-size: 16px;
          line-height: 24px;
        }
      }
    }
    .pay {
      padding: 21px 25px;
      .grand-total {
        padding-bottom: 40px;
        span:first-child {
          font-weight: 500;
          font-size: 18px;
          line-height: 27px;
        }
        span:last-child {
          font-weight: 500;
          font-size: 20px;
          line-height: 30px;
          // color: #a6100c;
        }
      }
      /deep/.el-radio {
        display: block;
        margin-bottom: 15px;
      }
      /deep/.el-button {
        width: 300px;
        height: 50px;
        margin-top: 15px;
      }
    }
    .pay-icon{
      height: 18px;
      position: relative;
      top: 4px;
    }
    .common-problem{
      padding: 15px 25px;
      h3 {
        font-weight: 500;
        font-size: 18px;
        line-height: 27px;
        color: #000000;
        padding-bottom: 25px;
      }
      p {
        font-weight: 500;
        font-size: 12px;
        line-height: 18px;
        text-decoration-line: underline;
        padding-bottom: 15px;
      }
    }
  }
}
.add-new-address {
  font-size: 14px;
  color: #99c41c;
  line-height: 30px;
  padding-bottom: 14px;
}
.address-item {
  width: 377px;
  border: 0.5px solid #cdd4dd;
  border-radius: 6px;
  padding: 15px 15px 26px 15px;
  margin-bottom: 17px;
  overflow: hidden;
  span {
    position: absolute;
    right: 10px;
    bottom: 4px;
    color: #99c41c;
  }
}
.activated-icon {
  display: none;
}
.address-item-activated {
  border: 0.5px solid #99c41c;
  .activated-icon {
    display: block;
    position: absolute;
    right: -35px;
    top: -35px;
    width: 60px;
    height: 60px;
    border-radius: 100px;
    background: #99c41c;
    color: white;
    i {
      position: absolute;
      bottom: 3px;
      left: 8px;
    }
  }
}
.mb10 {
  margin-bottom: 10px;
}
/deep/.el-table__empty-text {
  padding: 20px 0;
  line-height: 30px !important;
}
.class-red {
  color: #a6100c;
}
</style>
<style lang="scss" scoped>
.mobile-confirm-order {
  .mb10 {
    margin-bottom: .2rem;
  }
  .p-lr {
    padding: 0 .3rem;
  }
  >div, >p {
    background-color: #fff;
  }
  // padding: 0.3rem 0.3rem 1.04rem 0.3rem;
  .mobile-address-box    {
    position: relative;
    padding-bottom: 0.2rem;
    .mobile-address-info {
      white-space: pre-wrap;
      padding: 0 0.3rem 0 0.16rem;
      line-height: 0.35rem;
    }
    .icon-Frame_2 {
      position: absolute;
      right: .2rem;
      top: 50%;
      transform: translate(0, -50%);
    }
  }
  .mobile-confirm-order-delivery-time {
    padding-top: 0.15rem;
    span {
      color: #99c41c;
    }
  }
  .mobile-confirm-order-line {
    height: 0.96rem;
    border-bottom: solid 1px#DEDEDE;
    font-size: 0.28rem;
    .left {
      font-weight: 500;
    }
    .right {
      font-weight: 400;
      color: #7b7b7b;
    }
  }
  .mobile-confirm-order-remark {
    padding: 0 .1rem;
    /deep/ .el-textarea__inner{
      border: 0;
    }
  }
  .mobile-payment-method {
    padding-bottom: 0.3rem;
    div {
      height: 0.55rem;
    }
    .mobile-payment-method-title {
      font-weight: 500;
      font-size: 0.32rem;
      padding: 0.3rem 0;
    }
    .radio{
      display: inline-block;
      width: .32rem;
      height: .32rem;
      border: 0.5px solid #747A87;
      border-radius: 100%;
    }
    .radio-activated::after{
      content: '';
      display: block;
      width: .15rem;
      height: .15rem;
      border-radius: 100%;
      background: #99C41C;
      margin: .07rem 0 0 .065rem;
    }
    .pay-icon{
      height: .36rem;
      position: relative;
      top: 0.08rem;
    }
  }
  .mobile-confirm-order-product {
    padding: 0.32rem 0;
    border-bottom: #dedede 1px solid;
    position: relative;
    .mobile-confirm-order-product-img {
      width: 1.6rem;
      height: 1.6rem;
      border-radius: 8px;
      margin-right: 0.24rem;
      object-fit: cover;
    }
    .mobile-confirm-order-product-name {
      line-height: .38rem;
      max-width: 4rem;
      font-size: 0.32rem;
      font-weight: 500;
    }
    .mobile-confirm-order-product-color {
      color: #7b7b7b;
      font-size: 0.24rem;
    }
    .mobile-confirm-order-product-quantity {
      position: absolute;
      bottom: 0.18rem;
      left: 1.8rem;
    }
    .mobile-confirm-order-product-price {
      position: absolute;
      bottom: 0.3rem;
      right: 0;
      font-size: .28rem;
    }
    .mobile-confirm-order-product-price-discount {
      >span {
        color: #AB1E1A;
      }
      >s{
        font-size: .24rem;
        color: #B6B6B6;
        padding-right: .1rem;
      }
    }
    .icon-a-delete-bin-6-line5 {
      position: absolute;
      top: 0;
      right: 0;
      color: #7b7b7b;
    }
  }
  .mobile-confirm-order-product:last-child {
    border-bottom: 0
  }
  .mobile-confirm-order-amount {
    padding: 0.5rem .3rem 0.3rem .3rem;
    margin-bottom: 1.4rem;
    .mobile-confirm-order-amount-title {
      font-weight: 500;
      font-size: 0.32rem;
      padding-bottom: 0.2rem;
    }
  }
  .coupon {
      padding: .2rem .32rem;
      margin-bottom: .2rem;
      .title {
        font-size: 18px;
      }
      .coupon-code {
        margin: .2rem 0;
        height: .72rem;
        border-radius: .6rem;
        border: 1px solid #CDD4DD;
        position: relative;
        .coupon-code-input{
          width: 76%;
          /deep/.el-input__inner {
            height: .68rem;
            border: unset;
          }
        }
        .coupon-code-btn{
          border-radius: .6rem;
          position: absolute;
          right: 0;
          line-height: .28rem;
        }
      }
      .coupon-bar {
        width: 5.8rem;
        height: .64rem;
        border: .5px solid #E3444E;
        background: rgba(227, 68, 78, 0.03);
        border-radius: .08rem;
        margin: 0 auto;
        margin-top: .2rem;
      }
      .icon-a-close-line1 {
        border-radius: 50%;
        border: .5px solid #E3444E;
        font-size: .32rem;
        margin-right: .12rem;
      }
      .success {
        color: #99C41C;
      }
      .error {
        color: #E3444E;
      }
    }

  .vant-popup-title {
    margin-top: 16px;
    margin-left: 18px;
  }

  // 优惠券模块
  .cart-coupon {
    display: flex;
    padding: 10.4px 16.64px;
    margin-bottom: 10.4px;
    align-items: center;
    justify-content: space-between;
    .title {
      color: #10141D;
      font-size: 16px;
    }
    .tips {
      display: flex;
      align-items: center;
      justify-content: center;
      span {
        color: #B6B6B6;
        font-size: 12px;
      }
      i {
        color: #747A87;
      }
      .info {
        display: flex;
        color: #10141D;
        align-items: center;
        justify-content: center;
        i {
          color: #A6100C;
          font-size: 16px;
          margin-right: 5px;
        }
      }
      .chosen {
        color: #a6100c;
      }
    }
  }
}
/deep/.__bar-is-vertical{
  display: none !important;
}
.form-class{
  display: flex;
  justify-content: space-between;
}
.productParts {
  padding: .2rem .3rem 0;
  .title{
    font-size: .32rem;
    font-weight: 500;
    margin-bottom: 8px;
  }
  /deep/.el-checkbox{
    margin-bottom: 4px;
  }
}
</style>
